import styled from 'styled-components';
import { iPadDown } from './mediaQueries';

const StandardVerticalSpace = styled.div`
  height: 1.17vw;

  ${iPadDown} {
    height: 3.62vw;
  }
`;

export default StandardVerticalSpace;
